import type { IconData } from '@stacksjs/iconify-core'

export const kw1x1: IconData = {
  "body": "<defs><clipPath id=\"SVG6cd58CnG\"><path fill-opacity=\".7\" d=\"M0 0h496v496H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVG6cd58CnG)\" transform=\"scale(1.0321)\"><path fill=\"#fff\" d=\"M0 165.3h992.1v165.4H0z\"/><path fill=\"#f31830\" d=\"M0 330.7h992.1v165.4H0z\"/><path fill=\"#00d941\" d=\"M0 0h992.1v165.4H0z\"/><path fill=\"#000001\" d=\"M0 0v496l247.5-165.3l.5-165.5z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default kw1x1
